import { render, staticRenderFns } from "./activityPreviewGoal.vue?vue&type=template&id=4be5cfb3"
import script from "./activityPreviewGoal.vue?vue&type=script&lang=js"
export * from "./activityPreviewGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports